import React, { useState, useEffect } from 'react';
import { getJobs, saveJobs } from '../data/careersData';

const empty = { title: '', postedDate: '', closingDate: '', location: '', description: '' };
const ADMIN_USERNAME = 'egbadmin';
const ADMIN_PASSWORD = 'egbadmin2025';

const AdminCareers = () => {
  const [jobs, setJobs] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [saved, setSaved] = useState(false);
  const [preview, setPreview] = useState(null);
  const [auth, setAuth] = useState(!!localStorage.getItem('egb_admin_auth'));
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');

  useEffect(() => { if (auth) setJobs(getJobs().sort((a, b) => new Date(b.postedDate) - new Date(a.postedDate))); }, [auth]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (credentials.username === ADMIN_USERNAME && credentials.password === ADMIN_PASSWORD) {
      localStorage.setItem('egb_admin_auth', 'true');
      setAuth(true);
      setLoginError('');
    } else {
      setLoginError('Invalid username or password.');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('egb_admin_auth');
    setAuth(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let updated;
    if (editId !== null) {
      updated = jobs.map(j => j.id === editId ? { ...form, id: editId } : j);
    } else {
      const newId = jobs.length > 0 ? Math.max(...jobs.map(j => j.id)) + 1 : 1;
      updated = [...jobs, { ...form, id: newId }];
    }
    updated = updated.sort((a, b) => new Date(b.postedDate) - new Date(a.postedDate));
    saveJobs(updated);
    setJobs(updated);
    setForm(empty);
    setEditId(null);
    setShowForm(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleEdit = (job) => {
    setForm({ title: job.title, postedDate: job.postedDate, closingDate: job.closingDate, location: job.location, description: job.description });
    setEditId(job.id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = (id) => {
    if (!window.confirm('Are you sure you want to delete this job?')) return;
    const updated = jobs.filter(j => j.id !== id);
    saveJobs(updated);
    setJobs(updated);
  };

  const handleCancel = () => { setForm(empty); setEditId(null); setShowForm(false); };

  const formatDate = (d) => {
    if (!d) return '';
    const [y, m, day] = d.split('-');
    return `${m}/${day}/${y}`;
  };

  if (!auth) return (
    <section className="py-5 bg-light" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-4">
            <div className="card border-0 shadow p-4 rounded-4">
              <h4 className="fw-bold text-center mb-1">Admin Login</h4>
              <p className="text-muted text-center small mb-4">EGB Systems CMS</p>
              {loginError && <div className="alert alert-danger py-2 small">{loginError}</div>}
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label className="form-label fw-semibold small">Username</label>
                  <input type="text" className="form-control" value={credentials.username} onChange={e => setCredentials({ ...credentials, username: e.target.value })} placeholder="Enter username" required />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold small">Password</label>
                  <input type="password" className="form-control" value={credentials.password} onChange={e => setCredentials({ ...credentials, password: e.target.value })} placeholder="Enter password" required />
                </div>
                <button type="submit" className="btn btn-primary w-100 fw-bold">Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return (
    <>
      <section className="py-5 bg-light" style={{ minHeight: '80vh' }}>
        <div className="container py-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-0">Careers Admin Panel</h3>
              <small className="text-muted">EGB Systems CMS</small>
            </div>
            <div className="d-flex gap-2">
              {!showForm && (
                <button className="btn btn-primary fw-bold" onClick={() => { setForm(empty); setEditId(null); setShowForm(true); }}>
                  + Post New Job
                </button>
              )}
              <button className="btn btn-outline-secondary" onClick={handleLogout}>Logout</button>
            </div>
          </div>

          {saved && <div className="alert alert-success">✅ Job saved successfully!</div>}

          {/* Form */}
          {showForm && (
            <div className="card border-0 shadow-sm p-4 mb-5 rounded-4">
              <h5 className="fw-bold mb-4">{editId ? 'Edit Job' : 'Post New Job'}</h5>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small">Job Title *</label>
                    <input type="text" className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="e.g. Full Stack Developer" required />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small">Work Location *</label>
                    <input type="text" className="form-control" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} placeholder="e.g. Chennai, India" required />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small">Job Posted Date * (MM/DD/YYYY)</label>
                    <input type="date" className="form-control" value={form.postedDate} onChange={e => setForm({ ...form, postedDate: e.target.value })} required style={{ textTransform: 'uppercase' }} />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-semibold small">Job Closing Date * (MM/DD/YYYY)</label>
                    <input type="date" className="form-control" value={form.closingDate} onChange={e => setForm({ ...form, closingDate: e.target.value })} required style={{ textTransform: 'uppercase' }} />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-semibold small">Job Description *</label>
                    <textarea className="form-control" rows={5} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Enter full job description..." required></textarea>
                  </div>
                  <div className="col-12 d-flex gap-2">
                    <button type="submit" className="btn btn-primary fw-bold px-4">{editId ? 'Update Job' : 'Post Job'}</button>
                    <button type="button" className="btn btn-outline-secondary px-4" onClick={handleCancel}>Cancel</button>
                  </div>
                </div>
              </form>
            </div>
          )}

          {/* Jobs Table */}
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <table className="table table-hover mb-0">
              <thead className="table-dark">
                <tr>
                  <th>Job Title</th>
                  <th>Location</th>
                  <th>Posted Date</th>
                  <th>Closing Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {jobs.length === 0 && (
                  <tr><td colSpan={6} className="text-center text-muted py-4">No jobs posted yet.</td></tr>
                )}
                {jobs.map(job => {
                  const today = new Date().toISOString().split('T')[0];
                  const isActive = job.closingDate >= today;
                  return (
                    <tr key={job.id}>
                      <td className="fw-semibold">{job.title}</td>
                      <td>{job.location}</td>
                      <td>{formatDate(job.postedDate)}</td>
                      <td>{formatDate(job.closingDate)}</td>
                      <td><span className={`badge ${isActive ? 'bg-success' : 'bg-secondary'}`}>{isActive ? 'Active' : 'Closed'}</span></td>
                      <td>
                        <div className="d-flex gap-2">
                          <button className="btn btn-sm btn-outline-info" onClick={() => setPreview(job)}>Preview</button>
                          <button className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(job)}>Edit</button>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(job.id)}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Preview Modal */}
      {preview && (
        <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)', position: 'fixed', inset: 0, zIndex: 1050 }} onClick={() => setPreview(null)}>
          <div className="modal-dialog modal-lg modal-dialog-centered" onClick={e => e.stopPropagation()}>
            <div className="modal-content rounded-4">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">{preview.title}</h5>
                <button className="btn-close" onClick={() => setPreview(null)}></button>
              </div>
              <div className="modal-body">
                <div className="d-flex flex-wrap gap-3 mb-3">
                  <span className="small text-muted">📍 {preview.location}</span>
                  <span className="small text-muted">📅 Posted: {formatDate(preview.postedDate)}</span>
                  <span className="small text-danger fw-semibold">⏰ Closes: {formatDate(preview.closingDate)}</span>
                </div>
                <hr />
                <h6 className="fw-bold">Job Description</h6>
                <p className="text-muted" style={{ lineHeight: 1.8 }}>{preview.description}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-secondary" onClick={() => setPreview(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminCareers;
